import React from "react";
import TransportationNotifications from "../../transportationNotifications/transportationNotifications";

function TicketNotifications() :JSX.Element {
    return (
        <div className="transportation-ticket-notifications">
            <TransportationNotifications
                element="ticket"
            />
        </div>
    );
}

export default TicketNotifications;
